import { useQuery } from '@tanstack/react-query';
import { facilitiesApi } from '../lib/api-client';

export interface AssessableFacility {
  id: string;
  title: string;
  identifierNumber: string;
  coordinates: string;
  location: {
    id: string;
    name: string;
    locationType: string;
  };
  facilityType: {
    id: string;
    name: string;
    nameKinyarwanda: string;
    nameFrench: string;
  };
  canAssess: boolean;
  reason: string;
  existingAssessment: {
    id: string;
    committeeLevel: string;
    committeeName: string;
    percentageScore: number;
    createdAt: string;
  } | null;
}

export interface AssessableFacilitiesResponse {
  weekNumber: number;
  year: number;
  committee: {
    id: string;
    name: string;
    committeeLevel: string;
    geoLocation: {
      id: string;
      name: string;
    };
  };
  totalFacilities: number;
  assessableFacilitiesCount: number;
  facilities: AssessableFacility[];
}

export const useAssessableFacilities = (params?: {
  facilityTypeId?: string;
  subcategoryId?: string;
  weekNumber?: number;
  year?: number;
  locationId?: string;
  assessmentType?: 'HYGIENE' | 'COMPLIANCE';
}) => {
  return useQuery({
    queryKey: ['assessable-facilities', params],
    queryFn: async (): Promise<AssessableFacilitiesResponse> => {
      const apiResponse = await facilitiesApi.getAssessableFacilities({
        locationId: params?.locationId,
        weekNumber: params?.weekNumber,
        year: params?.year,
        facilityTypeId: params?.facilityTypeId,
        subcategoryId: params?.subcategoryId,
        assessmentType: params?.assessmentType ?? 'HYGIENE',
      } as any);

      const response = apiResponse as unknown as AssessableFacilitiesResponse;
      return response;
    },
    enabled: true,
    staleTime: 1000 * 60 * 5,
  });
};
